
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent, PropType } from 'vue';
import NumberSpinner from "../../components/form-elements/NumberSpinner.vue";
import {
    convertInCurrency
} from "../../utils/utils";
// @ts-ignore
import Popper from 'vue3-popper/dist/popper.esm';
import {useTicketStore} from "../../stores/TicketStore";
import {storeToRefs} from 'pinia';

export default defineComponent({
    name: "PriceGroupConfigurations",
    components: {
        NumberSpinner,
        Popper
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        allPriceGroups: {
            type: Array,
            required: true,
        },
        selectedPriceConfiguration: {
            type: Object,
            required: true
        },
        ticketConfiguration: {
            type: Object,
            required: true
        },
        selectedCurrency: {
            type: String,
            required: true
        }
    },
    emits: ['changePriceGroupCounter'],
    setup(props, { emit }) {
        const ticketStore = useTicketStore();
        const {
            ticketConfigurations
        } = storeToRefs(ticketStore);

        const pricePerPriceGroup = (priceGroup: String) => {
            if(!props.selectedPriceConfiguration || !props.selectedPriceConfiguration?.priceByPriceGroup) {
                return 0;
            }
            return props.selectedPriceConfiguration.priceByPriceGroup ? props.selectedPriceConfiguration.priceByPriceGroup.filter((element) => element.id === priceGroup)[0] : {};
        }

        const onChangeCounter = (value: Number, priceGroup: String) => {
            emit('changePriceGroupCounter', value, {
                id: priceGroup,
                price: pricePerPriceGroup(priceGroup)
            });
        }

        const getPriceGroupSum = (price: Number, priceGroupCounter: Number) => {
            return price * priceGroupCounter;
        }

        const getCounter = (priceGroup: String) => {
            return props.ticketConfiguration['priceGroups'][priceGroup]?.counter;
        }
        
        const getTotal = () => {
            let total = 0;
            props.allPriceGroups.forEach(function(priceGroup) {
                if(props.ticketConfiguration['priceGroups'][priceGroup.value]?.counter) {
                    total += getPriceGroupSum(pricePerPriceGroup(priceGroup.value).price, props.ticketConfiguration['priceGroups'][priceGroup.value].counter);
                }
            })

            return total;
        }

        return {
            pricePerPriceGroup,
            getPriceGroupSum,
            getTotal,
            onChangeCounter,
            convertInCurrency,
            getCounter,
            translate
        }
    }
})
